import React from "react";

import Entry from "./Entry";
import ChannelSelection from "src/banking/authentication/ForgotFlow/ChannelSelection";
import LoginRedirect from "src/banking/authentication/ForgotFlow/LoginRedirect";
import { handleCurrentState } from "../handleCurrentState";

export default {
  entry: Entry,
  selectChannel: props => (
    <ChannelSelection
      handleCurrentState={handleCurrentState}
      channelSelectionDescription={"olb.login.forgotUsernameChannelDescription"}
      {...props}
    />
  ),
  forgotChallengeQuestionsComplete: () => (
    <LoginRedirect successMessage={"olb.login.resetUsername.success"} />
  ),
};



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotLogin/ForgotUsername/steps/index.js